import { ListItem, ListItemIcon, ListItemText, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { HourlyPayLabel } from "@src/appV2/redesign/Pay/HourlyPayLabel";
import { type ModalShiftOfferData } from "@src/appV2/redesign/Shift/types";

interface PayProps {
  offer: ModalShiftOfferData;
}

export function ListItemPay(props: PayProps) {
  const { offer } = props;

  return (
    <ListItem divider>
      <ListItemIcon iconType="extra-pay" />
      <ListItemText
        disableTypography
        primary={
          <Stack direction="row" spacing={3} alignItems="center">
            <Text semibold variant="h6">
              Posted Rate:
            </Text>
            <HourlyPayLabel size="medium" hourlyPay={offer.attributes.formattedHourlyPay} />
          </Stack>
        }
      />
    </ListItem>
  );
}
